import { useSearchParams } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { Footer } from "../components/Footer";
import Academy from "./Academy";
import useSeo from "../hooks/useSeo";

export default function Courses() {
  const { t, lang } = useLang();
  const [searchParams] = useSearchParams();

  useSeo({
    lang,
    title: lang === "en" ? "Sports Science Courses & Learning Paths" : "Μαθήματα Αθλητικής Επιστήμης & Μονοπάτια Μάθησης",
    description:
      lang === "en"
        ? "Browse all SportScience Academy online courses and learning paths: coaching, physiology, nutrition, rehab and fitness business. Self-paced, with quizzes and certificates."
        : "Δες όλα τα online μαθήματα και τα μονοπάτια μάθησης της SportScience Academy: προπονητική, φυσιολογία, διατροφή, αποκατάσταση και fitness business. Με δικό σου ρυθμό, quiz και πιστοποιητικά.",
  });

  return (
    <div data-testid="courses-page">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 pt-14 pb-20">
        <span className="eyebrow">
          <span className="w-7 h-px bg-[#1D4ED8]" />
          {t("courses.subtitle")}
        </span>
        <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl mt-5 text-[#0B1B3A]" data-testid="courses-title">
          {t("courses.title")}
        </h1>
        <p className="text-base text-[#475569] mt-4 max-w-3xl">{t("academy.subtitle")}</p>
        <Academy embedded initialCategory={searchParams.get("category") || "all"} />
      </div>
      <Footer />
    </div>
  );
}
